import { components } from "api/schema/api-schema";
import { Graph } from "components/WorkflowEditor/WorkflowDiagram/Graph";
import {
  RunStatusNode,
  RunStatusNodeProps,
} from "components/WorkflowEditor/WorkflowDiagram/Nodes/RunStatusNode";

export interface TabStatusGraphProps {
  progress: components["schemas"]["RunProgress"];
}

const nodeTypes = {
  runStatus: (props: RunStatusNodeProps) => <RunStatusNode {...props} />,
} as const;

export const TabStatusGraph = ({ progress }: TabStatusGraphProps) => {
  return (
    <Graph
      nodes={progress.nodes.map((n) => {
        const status = n.status;
        return {
          id: n.id,
          data: {
            label: n.label,
            runStatus: status,
          },
          type: "runStatus" as const,
        };
      })}
      edges={progress.edges.map((e) => ({
        id: e.source_id + e.target_id,
        source: e.source_id,
        target: e.target_id,
      }))}
      nodeTypes={nodeTypes}
    />
  );
};
